interface ParsePageTypeReturn {
  type: string;
}

export function searchArticleCid(slug: string ): ParsePageTypeReturn | undefined {

  function extractCid(data: string) {
    const cid = data.match(/1\..*/)
    return cid?.length ? cid?.[0] : null
  }

  const cid = extractCid(slug)

  if (cid) {
    return {
      type: 'article'
    }
  } else {
    return {
      type: ''
    }
  }
}